import React, { Component } from 'react';
import classes from './main.css';
import { connect } from "react-redux";

class Main extends React.Component {

state  = {
  roomName:'',
  selRoom:'Default',
  flag:false
};

addRoom = () => {
  var roomName = this.state.roomName;
  this.props.dispatch({type:"ADD_CHATROOM",roomName });
  this.setState({roomName:''});
}

switchuser = () => {
  this.props.dispatch({type:"SWTICH_USER"});
}

roomName = (event) => {
 this.setState({roomName:event.target.value});
}

selectedRoom = (item,index) => {

  var selRoom  = item.room;
  var selIndex = index;

  this.props.dispatch({type:"SELECTCHAT_ROOM",selRoom,selIndex });

}

 render() {

   let roomSec = null;

   console.log('Inside Render of main');
   console.log(this.props.data);

   roomSec = (
   this.props.data.map((item,index) => (
           <div className={classes.roombody}>
             <ul className={classes.ulstyle} onClick={() => this.selectedRoom(item,index)}>{item.room}</ul>
          </div>
      ))
   );

  return (

  <div className={classes.roombody}>
     <br />
     <button className={classes.switch} onClick={this.switchuser} > Switch User </button>
     <h4 className={classes.selRoom}>Chat Room: &nbsp; {this.props.selRoom}</h4>
     <br />
    <button onClick={this.addRoom} className={classes.btn} >
       Add Chat Room
     </button>

     <input type="text" onChange={this.roomName} value={this.state.roomName} className={classes.inpBox}  />
      {roomSec}

    </div>
   );
  }
}

const mapStateToProps = state => {
  console.log('Inside mapstatetoprops of Main');
  console.log(state);
    return {
    data: state.data,
    selRoom: state.selRoom,
    selIndex:state.selIndex
  };
};

export default connect(
  mapStateToProps
)(Main);
